import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=6dc1731c&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "./dialog.vue?vue&type=style&index=0&id=6dc1731c&prod&lang=scss&"
import style1 from "./dialog.vue?vue&type=style&index=1&id=6dc1731c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc1731c",
  null
  
)

export default component.exports